// NPM Imports
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

// action imports
import showNavbar from "../../../actions/NavbarWrapperAction";

import { IMAGE_URLS } from "../../../constants";

const { fourofour: errorImage } = IMAGE_URLS;

class Error404 extends Component {
  state = {};

  componentDidMount() {
    this.props.showNavbar(true);
  }

  componentWillUnmount() {
    this.props.showNavbar(false);
  }

  render() {
    return (
      <div className="error404-wrapper">
        <img src={errorImage} alt="" />
        <div className="error404-body">
          <span className="error404-title">
            Hmm! Looks like the page you&apos;re looking for doesn&apos;t exist.
          </span>
          <span className="error404-msg">
            <Link to="/assets">Go to the Documents page</Link> in your Revv
            account and you can navigate from there.
          </span>

          <span className="error404-tip">
            <span aria-label="bulb" role="img">
              &#128161;
            </span>{" "}
            Tip: If you have multiple Revv accounts and are trying to switch
            between them, log out and log in again into the right account.
          </span>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = { showNavbar };

export default connect(null, mapDispatchToProps)(Error404);
